exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nav#navbar {\n  -webkit-box-flex: 0;\n          flex: 0;\n  -ms-flex: 0;\n  -ms-flex-preferred-size: auto;\n\n}\n\nmain#body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n          flex: 1;\n  -ms-flex: 1;\n  -ms-flex-preferred-size: auto;\n}\n\nfooter#footer {\n  height: 60px;\n  -webkit-box-flex: 0;\n          flex: 0;\n  flex-basis: 60px;\n  -ms-flex: 0;\n  -ms-flex-preferred-size: 60px;\n}\n\nfooter#footer .copyright {\n  color: #777;\n  display: block;\n  position: relative;\n  float: left;\n  top: 30px;\n  margin-top: -9px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/snowriders/app/src/app/snowriders.component.css
// module id = ../../../../../src/app/snowriders.component.css
// module chunks = main